import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'sonner'
import App from './App'
import './index.css'
import { loadSettings, applyThemeToDocument } from './utils/settingsStorage'

applyThemeToDocument(loadSettings())
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  const s = loadSettings()
  if (s.theme === 'system') applyThemeToDocument(s)
})

function readTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

function AppToaster() {
  const [theme, setTheme] = useState(readTheme)
  useEffect(() => {
    const obs = new MutationObserver(() => setTheme(readTheme()))
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => obs.disconnect()
  }, [])
  return (
    <Toaster
      position="bottom-right"
      richColors
      closeButton
      theme={theme}
      offset="80px"
      toastOptions={{
        style: { fontFamily: 'Inter, system-ui, sans-serif' },
      }}
    />
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <AppToaster />
  </React.StrictMode>
)
